
import Vue from 'vue'
import { RIcon, RButton } from '@/components'
import { routerPush } from '@/services/routing'

export default Vue.extend({
  name: 'Welcome',
  components: {
    RIcon,
    RButton,
  },
  methods: {
    handleClick(): void {
      routerPush(this.$router, '/setup')
    },
    handleSkip(): void {
      localStorage.setItem('skipSetup', 'true')
      routerPush(this.$router, '/dashboard')
    },
  },
})
